<template>
  <div class="homePage" v-if="isMobile != undefined">
    <div class="PCHomePage" v-if="!isMobile">
      <div class="word font" :class="mounted ? 'wordIn' : 'wordOut'">
        <div class="name" v-for="(k, i) in word.name" :key="i">
          {{ word.name[i] }}<span v-if="i < word.name.length - 2">，</span><span
            v-if="i == word.name.length - 2">。</span>
        </div>
        <div class="from">——{{ word.from }}</div>
      </div>
      <div class="list" :class="mounted ? 'listIn' : 'listOut'">
        <div class="item" v-for="(k, i) in list" :key="i" @click="to(k.to)">
          <img :src="require('../assets/img/' + k.img)" />
          <div class="text font2">{{ k.name }}</div>
        </div>
      </div>
      <div class="weather font2" :class="mounted ? 'weatherIn' : 'weatherOut'">
        <div class="city-tem" v-if="nowWeather !== undefined">
          {{ nowWeather.city }} {{ nowWeather.tem }}℃
        </div>
        <img v-if="nowWeather !== undefined" :src="require(`../assets/img/weather/${nowWeather.wea_img}.png`)"
          :alt="nowWeather.wea" :class="nowWeather.wea_img == 'qing' || nowWeather.wea_img == 'xue'
    ? 'circular'
    : ''
    " />
      </div>
      <a href="https://beian.miit.gov.cn/" class="beian">粤ICP备2023082288号-1</a>
    </div>
    <div class="MHomePage" v-if="isMobile">
      <div class="word font" :class="mounted ? 'wordIn' : 'wordOut'">
        <div class="name" v-for="(k, i) in word.name" :key="i">
          {{ word.name[i] }}<span v-if="i < word.name.length - 2">，</span><span
            v-if="i == word.name.length - 2">。</span>
        </div>
        <div class="from">——{{ word.from }}</div>
      </div>
      <div class="list" :class="mounted ? 'listIn' : 'listOut'">
        <div class="item" v-for="(k, i) in list" :key="i" @click="to(k.to)">
          <img :src="require('../assets/img/' + k.img)" />
          <div class="text font2">{{ k.name }}</div>
        </div>
        <div class="weather font2" :class="mounted ? 'weatherIn' : 'weatherOut'" v-if="nowWeather !== undefined">
          <div class="city-tem">
            {{ nowWeather.city }} {{ nowWeather.tem }}℃
          </div>
          <img :src="require(`../assets/img/weather/${nowWeather.wea_img}.png`)" :alt="nowWeather.wea" :class="nowWeather.wea_img == 'qing' || nowWeather.wea_img == 'xue'
    ? 'circular'
    : ''
    " />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/mouse.js"; //鼠标跟随点击粒子
import "../assets/mouse2.js"; //修改鼠标
document.onselectstart = function () {
  return false; //禁止双击
};
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      //列表
      list: [
        //网易云音乐
        // {
        //   name: "音乐",
        //   to: "http://www.lhbbb.top:3002",
        //   img: "music.png",
        // },
        //爱心
        {
          name: "爱 心",
          to: "/pages/love/index.html",
          img: "love.png",
        },
        {
          name: "烟 花",
          to: "/pages/firework/index.html",
          img: "love.png",
        },
      ],
      mounted: false,
      word: {
        from: "",
        name: "",
      },
      nowWeather: undefined,
      token: "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",
    };
  },
  mounted() {
    console.log(this.isMobile);
    this.getData();
  },
  methods: {
    to(path) {
      window.location.href = path;
    },
    //获得首页数据
    async getData() {
      //请求
      const res = this.$http.get("https://api.apiopen.top/api/sentences"); //每日一句
      const res2 = this.$http.get(
        "https://www.yiketianqi.com/free/day?appid=65554911&appsecret=G3HvRzyX&unescape=1&vue=1"
      ); //天气
      //让多个请求同步
      const word = await res;
      this.mounted = true; //每日一句解析成功了就可以开启淡入效果
      const nowWeather = await res2;
      console.log("每日一句", word.data.result);
      console.log("实况天气", nowWeather.data);
      //处理数据 赋值
      let name = word.data.result.name;
      name = name.split(/[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a]/); //分隔为数组
      this.word = {
        name,
        from: word.data.result.from,
      };
      this.nowWeather = nowWeather.data;
      // const res2 = await this.$http.get("https://tenapi.cn/lishi/");
      // console.log("历史上的今天", res2);
      // const res6 = await this.$http.get(
      //   "https://tenapi.cn/video/?url=https://share.izuiyou.com/hybrid/share/post?pid=163566379"
      // );
      // console.log("短视频", res6);
    },
  },
};
</script>

<style lang="less" scoped>
.homePage {
  height: 100%;
  width: 100%;
}

.PCHomePage {
  width: 100%;
  height: 100%;
  color: rgba(238, 238, 238, 0.7826);

  //   background-color: antiquewhite;
  //   background-color: antiquewhite;
  .beian {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%);
    color: #bfb1bb;
    text-decoration: none;
  }

  .word {
    position: absolute;
    bottom: 100px;
    left: 100px;
    // width: 50%;
    // font-weight: 700;
    font-size: 60px;
    text-shadow: 5px 5px 5px black;
    transition: all 2s;

    .from {
      text-shadow: none;
      font-size: 30px;
      text-align: right;
      text-shadow: 2px 2px 5px black;
    }
  }

  .wordIn {
    bottom: 100px;
    opacity: 1;
  }

  .wordOut {
    bottom: 50px;
    opacity: 0;
  }

  .list {
    position: absolute;
    bottom: 100px;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.123);
    border-radius: 10px;
    transition: all 2s;
    display: flex;
    justify-content: center;

    .item {
      height: 100%;
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 5px;
      transition: all 0.8s;
      border-radius: 10px;
      opacity: 0.6;
      border: none;

      &:hover {
        background-color: rgba(0, 0, 0, 0.23);
        opacity: 1;
      }

      img {
        width: 50px;
        height: 50px;
      }

      .text {
        height: 20px;
        text-align: center;
        font-size: 13px;
        margin-top: 2px;
      }
    }
  }

  .listIn {
    right: 150px;
    opacity: 1;
  }

  .listOut {
    right: 0;
    opacity: 0;
  }

  .weather {
    position: absolute;
    bottom: 200px;
    right: 150px;
    transition: all 2s;
    display: flex;
    align-items: center;

    .city-tem {
      font-size: 20px;
      color: rgba(238, 238, 238, 0.747);
    }

    img {
      width: 30px;
      height: 30px;
      margin-left: 3px;
    }
  }

  .weatherIn {
    right: 150px;
    opacity: 1;
  }

  .weatherOut {
    right: 0;
    opacity: 0;
  }
}

.MHomePage {
  width: 100%;
  height: 100%;
  color: rgba(238, 238, 238, 0.7826);

  .word {
    position: absolute;
    left: 0.5rem;
    transform: translateY(-100%);
    font-size: 1rem;
    font-weight: 500;
    text-shadow: 0.2rem 0.2rem 0.2rem black;
    transition: all 2s;

    .from {
      text-shadow: none;
      font-size: 0.4rem;
      text-align: right;
      color: black;
      text-shadow: 0.01rem 0.01rem 0.01rem black;
    }
  }

  .wordIn {
    top: 50%;
    opacity: 1;
  }

  .wordOut {
    top: 40%;
    opacity: 0;
  }

  .list {
    position: absolute;
    bottom: 0rem;
    left: 50%;
    transform: translate(-50%);
    // height: 1.5rem;
    background-color: rgba(0, 0, 0, 0.123);
    border-radius: 0.105rem;
    transition: all 2s;
    display: flex;
    justify-content: center;

    .item {
      height: 100%;
      width: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 0.1rem;
      transition: all 0.8s;
      border-radius: 0.1rem;
      opacity: 0.6;
      border: none;

      &:hover {
        background-color: rgba(0, 0, 0, 0.23);
        opacity: 1;
      }

      img {
        width: 1rem;
        height: 1rem;
      }

      .text {
        height: 20px;
        text-align: center;
        font-size: 13px;
        margin-top: 2px;
      }
    }
  }

  .listIn {
    bottom: 0rem;
    opacity: 1;
  }

  .listOut {
    bottom: 2rem;
    opacity: 0;
  }

  .weather {
    position: absolute;
    top: -10%;
    left: 50%;
    transform: translate(-50%, -100%);
    transition: all 2s;
    display: flex;
    align-items: center;

    .city-tem {
      width: 2rem;
      font-size: 0.4rem;
      color: rgba(238, 238, 238, 0.747);
    }

    img {
      width: 0.6rem;
      height: 0.6rem;
      margin-left: 0.025rem;
    }
  }
}
</style>